import React from 'react';

import { useCompetitions } from '../../contexts/Competitions';

const ListCompSelect = ({
  value = {},
  onChange = () => {},
  questionSet = false,
}) => {
  const { competitions, find } = useCompetitions();

  return (
    <div className="form-row">
      <div className="col-auto">
        <select
          className="custom-select"
          value={value.competition || ''}
          onChange={(e) => {
            const v = e.target.value;

            onChange(v ? { competition: v } : {});
          }}
        >
          <option value="">All Competitions</option>
          {competitions.map((c) => (
            <option
              key={c._id}
              value={c._id}
            >{c.refCode}</option>
          ))}
        </select>
      </div>
      {questionSet && value.competition && (
        <div className="col-auto">
          <select
            className="custom-select"
            value={value.questionSet || ''}
            onChange={(e) => {
              const v = e.target.value;
              const f = { ...value };

              if (v) f.questionSet = v;
              else delete f.questionSet;

              onChange(f);
            }}
          >
            <option value="">All Question Banks</option>
            {
              find(value.competition).competition.questionSets
                .map((qs) => (
                  <option
                    key={qs._id}
                    value={qs._id}
                  >{qs.refCode}</option>
                ))
            }
          </select>
        </div>
      )}
    </div>
  );
};

export default ListCompSelect;
